/* eslint-disable jsx-a11y/prefer-tag-over-role */
import React from 'react';
import { MainGridRow } from './MainGridRow';

export const MainGrid = ({ headers, rows, onOpenModal }) => {
  const totalColumns = Math.max(
    headers.reduce((count, header) => {
      return count + (header.subheaders ? header.subheaders.length : 1);
    }, 0),
    1
  );

  const gridStyle = {
    backgroundColor: '#fff',
    display: 'grid',
    gridTemplateColumns: `repeat(${totalColumns}, minmax(min-content, 1fr))`,
  };

  // subgrid makes every row reuse the parent's already-computed column
  // tracks instead of each row computing its own min-content independently
  const rowGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'subgrid',
    gridColumn: `1 / span ${totalColumns}`,
  };

  // Always render at least one row for ARIA compliance
  const hasHeaders = headers && headers.length > 0;
  const hasRows = rows && rows.length > 0;
  return (
    <div style={gridStyle} role="grid" aria-label="Monitoring report data">
      {/* Header row - display:contents preserves CSS grid layout */}
      {hasHeaders ? (
        <div role="row" style={rowGridStyle}>
          {headers.map((header, index) => {
            if (typeof header === 'string') {
              const isDetailsHeader = header === 'Details';
              const style = { gridRow: '1 / 3' };
              if (isDetailsHeader) {
                style.gridColumn = `${totalColumns}`;
              }
              return (
                <div key={index} className="grid-header-main single" style={style} role="columnheader">
                  {header}
                </div>
              );
            } else {
              return (
                <React.Fragment key={index}>
                  <div className="grid-header-main split-main-title" style={{ gridColumn: `span ${header.subheaders.length}` }} role="columnheader">
                    {header.title}
                  </div>
                  {header.subheaders.map((subheader, subIndex) => (
                    <div key={subIndex} className="grid-header-main split-subheader" role="columnheader">
                      {subheader}
                    </div>
                  ))}
                </React.Fragment>
              );
            }
          })}
        </div>
      ) : (
        <div role="row" style={rowGridStyle}>
          <div role="columnheader" style={{ gridColumn: `1 / span ${Math.max(totalColumns, 1)}` }}>No data</div>
        </div>
      )}

      {/* Data rows */}
      {hasRows ? (
        rows.map((row, index) => (
          <MainGridRow 
            key={row.id} 
            row={row} 
            rowIndex={index} 
            onOpenModal={onOpenModal} 
            totalColumns={totalColumns}
            rowGridStyle={rowGridStyle}
          />
        ))
      ) : (
        <div role="row" style={rowGridStyle}>
          <div role="gridcell" style={{ gridColumn: `1 / span ${Math.max(totalColumns, 1)}` }}>No data available</div>
        </div>
      )}
    </div>
  );
};